
<div class="nav-bar"
     [class.is-slideshow-active]="slideshowActive"
     [class.is-project-mode]="projectMode"
     [class.is-project-mode-qa]="projectModeQa"
     [class.is-project-mode-uat]="projectModeUat"
     [class.has-floating-builder-toolbar]="!projectMode"
     [style.--environment-sidenav-color]="sidenavColor"
     [style.--dvm-sidebar-bg]="sidenavColor"
     style="--top-toolbar-height: calc((40px * var(--dvm-font-scale, 1)) + 16px); height: var(--dvh, 100vh); min-height: var(--dvh, 100vh); overflow: hidden;">

  <!-- TOP TOOLBAR -->
      <mat-toolbar
      class="d-flex justify-content-between align-items-center px-3 custom-toolbar-shadow"
      [class.is-builder-floating-toolbar]="!projectMode"
      [style.--environment-header-color]="topHeaderColor"
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 1001; padding: 0.5rem; height: var(--top-toolbar-height); min-height: var(--top-toolbar-height); box-sizing: border-box; background-color: var(--dvm-toolbar-bg, #9ccafb); color: var(--dvm-toolbar-text, rgb(37, 32, 97));">

      <div class="d-flex align-items-center">
        <button mat-icon-button class="mobile-menu-toggle me-2" *ngIf="isMobileLayout && !isSelfServiceRoute" (click)="toggleSidebar()"
          style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));" aria-label="Toggle navigation menu">
          <mat-icon>menu</mat-icon>
        </button>

      <!-- Use Case 2a: Client logo image provided → show image alone -->
      <img *ngIf="hasClientLogo && clientLogo"
           [src]="clientLogo"
           alt="Client Logo"
           class="primary-logo"
           style="margin-right: 6px;">

      <!-- Use Case 2b: Client icon + text provided → show mat-icon + text -->
      <ng-container *ngIf="hasClientLogo && !clientLogo && clientIcon">
        <span class="client-icon-wrap">
          <mat-icon class="client-icon">{{ clientIcon }}</mat-icon>
        </span>
        <span class="fw-bold fs-5 company-text">{{ clientText }}</span>
      </ng-container>

      <!-- Use Case 1: No client logo → show SIM Advisory default branding (logo + company text) -->
        <ng-container *ngIf="!hasClientLogo">
          <img [src]="logo" alt="Logo"
               class="primary-logo"
               [style.height.px]="useAltSidenav ? 30 : null"
               [style.width.px]="useAltSidenav ? 40 : null"
               style="margin-right: 6px;">
          <span class="fw-bold fs-5 company-text navbar-brand-title">{{ companyText }}</span>
        </ng-container>

      <span *ngIf="dashboardTitle"
            class="dashboard-title-inline"
            [style.font-size]="dashboardTitleFontSize || null">
        {{ dashboardTitle }}
      </span>
      </div>

      <nav
        *ngIf="topNavigationSections.length && !projectMode"
        class="builder-top-navigation"
        aria-label="Application navigation"
        (mouseleave)="scheduleTopNavigationClose()"
        (keydown.escape)="closeTopNavigation()"
      >
        <div
          *ngFor="let section of topNavigationSections"
          class="builder-top-navigation-entry"
          (mouseenter)="openTopNavigation(section.id)"
          (focusin)="openTopNavigation(section.id)"
        >
          <button
            type="button"
            class="builder-top-navigation-trigger"
            [class.is-active]="activeTopNavigationId === section.id"
            [attr.aria-expanded]="activeTopNavigationId === section.id"
            [attr.aria-controls]="'builder-navigation-panel-' + section.id"
          >
            <mat-icon *ngIf="section.icon">{{ section.icon }}</mat-icon>
            <span>{{ section.label }}</span>
            <mat-icon class="builder-top-navigation-chevron">expand_more</mat-icon>
          </button>

          <section
            *ngIf="activeTopNavigationId === section.id"
            class="builder-navigation-panel"
            [class.is-list]="section.layout === 'list'"
            [attr.id]="'builder-navigation-panel-' + section.id"
            (mouseenter)="openTopNavigation(section.id)"
            (mouseleave)="scheduleTopNavigationClose()"
          >
            <!-- List panels get a compact header (label + live count); card
                 panels keep the roomier icon + description header. -->
            <header class="navigation-list-header" *ngIf="section.layout === 'list'">
              <strong>{{ section.label }}</strong>
              <span class="navigation-list-count" *ngIf="!isSectionLoading(section)">{{ section.resolvedItems.length }}</span>
              <span class="navigation-spinner" *ngIf="isSectionLoading(section)" aria-hidden="true"></span>
              <small *ngIf="section.description">{{ section.description }}</small>
            </header>

            <header class="builder-navigation-panel-header" *ngIf="section.layout !== 'list'">
              <span>
                <mat-icon *ngIf="section.icon">{{ section.icon }}</mat-icon>
              </span>
              <div>
                <strong>{{ section.label }}</strong>
                <small>{{ section.description }}</small>
              </div>
            </header>

            <div class="navigation-loading" *ngIf="isSectionLoading(section)" role="status">
              <span class="navigation-spinner" aria-hidden="true"></span>
              <span>Loading dashboards…</span>
            </div>

            <ng-container *ngIf="!isSectionLoading(section) && section.resolvedItems.length; else emptyNavigationSection">
              <div class="navigation-list" *ngIf="section.layout === 'list'">
                <button
                  type="button"
                  class="navigation-list-row"
                  *ngFor="let item of section.resolvedItems"
                  [class.is-current]="isTopNavigationItemActive(item.path)"
                  [attr.title]="item.label"
                  [attr.aria-current]="isTopNavigationItemActive(item.path) ? 'page' : null"
                  (click)="navigateTopNavigationItem(item.path)"
                >
                  <span class="navigation-list-rail" aria-hidden="true"></span>
                  <mat-icon class="navigation-list-row-icon">{{ item.icon || 'dashboard' }}</mat-icon>
                  <span class="navigation-list-row-name">{{ item.label }}</span>
                  <span class="navigation-list-row-tag" *ngIf="isTopNavigationItemActive(item.path)">Viewing</span>
                  <mat-icon class="navigation-list-row-arrow" *ngIf="!isTopNavigationItemActive(item.path)">arrow_forward</mat-icon>
                </button>
              </div>

              <div class="builder-navigation-card-grid" *ngIf="section.layout !== 'list'">
                <button
                  type="button"
                  class="builder-navigation-card"
                  *ngFor="let item of section.resolvedItems"
                  [style.--navigation-card-accent]="item.accent || '#1769e0'"
                  (click)="navigateTopNavigationItem(item.path)"
                >
                  <span class="builder-navigation-card-media" [class.has-image]="!!item.image">
                    <img
                      *ngIf="item.image; else navigationItemIcon"
                      [src]="item.image"
                      [alt]="item.label + ' preview'"
                      (error)="useTopNavigationFallback($event, section.fallbackThumbnail)"
                    />
                    <ng-template #navigationItemIcon>
                      <mat-icon>{{ item.icon || 'open_in_new' }}</mat-icon>
                    </ng-template>
                  </span>
                  <span class="builder-navigation-card-copy">
                    <strong>{{ item.label }}</strong>
                    <small>{{ item.description }}</small>
                  </span>
                  <mat-icon class="builder-navigation-card-arrow">arrow_forward</mat-icon>
                </button>
              </div>
            </ng-container>

            <ng-template #emptyNavigationSection>
              <div class="builder-navigation-empty" *ngIf="!isSectionLoading(section)">
                <mat-icon>dashboard</mat-icon>
                <span>Publish a dashboard to see it here.</span>
              </div>
            </ng-template>
          </section>
        </div>
      </nav>


    <div class="d-flex align-items-center top-toolbar-right"
         style="gap: 12px;">
      <div class="navbar-profile-popover" tabindex="0" [attr.aria-label]="'Welcome ' + username">
        <button type="button" class="navbar-profile-trigger" tabindex="-1" aria-hidden="true">
          <!-- Secondary (Make-in-India) logo. SECONDARY_LOGO_ENABLED must be
               honoured here: at full size this image blows the 38px profile chip
               open and pushes account_circle out of the row. -->
          <img *ngIf="!useAltSidenav && showSecondaryLogo" [src]="secondaryLogo" alt=""
               class="secondary-logo">
          <mat-icon>account_circle</mat-icon>
        </button>
        <div class="navbar-hover-popup navbar-profile-popup" role="tooltip">
          <span class="navbar-hover-popup-icon">
            <mat-icon>person</mat-icon>
          </span>
          <span class="navbar-hover-popup-copy">
            <small>Welcome</small>
            <strong>{{ username }}</strong>
          </span>
          <span class="navbar-profile-status">
            <i></i>
            Active session
          </span>
        </div>
      </div>

      <div class="self-service-toolbar-actions" *ngIf="isSelfServiceRoute" aria-label="Visualization Builder tools">
        <div class="toolbar-action-popover">
          <!-- <button mat-icon-button class="toolbar-action-button"
                  (click)="triggerSelfServiceAction('whats-new')"
                  aria-label="What's New"
                  style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
            <mat-icon>campaign</mat-icon>
          </button> -->
          <div class="navbar-hover-popup" role="tooltip">
            <span class="navbar-hover-popup-icon">
              <mat-icon>campaign</mat-icon>
            </span>
            <span class="navbar-hover-popup-copy">
              <strong>What's New</strong>
              <small>Explore the latest updates</small>
            </span>
            <span class="navbar-hover-popup-action">Explore <mat-icon>arrow_forward</mat-icon></span>
          </div>
        </div>
        <!-- User Guide now lives in the global toolbar cluster, next to Theme Options. -->
        <div class="toolbar-action-popover">
          <button mat-icon-button class="toolbar-action-button"
                  (click)="triggerSelfServiceAction('chat')"
                  aria-label="Open Assist Chat"
                  style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
            <mat-icon>auto_awesome</mat-icon>
          </button>
          <div class="navbar-hover-popup" role="tooltip">
            <span class="navbar-hover-popup-icon">
              <mat-icon>auto_awesome</mat-icon>
            </span>
            <span class="navbar-hover-popup-copy">
              <strong>Assist Chat</strong>
              <small>Get help with your workspace</small>
            </span>
            <span class="navbar-hover-popup-action">Start chat <mat-icon>arrow_forward</mat-icon></span>
          </div>
        </div>
      </div>

      <!-- Published-dashboard settings: gear menu bridged up from
           DvmPublishedDashboardComponent (Edit Layout / Reset / Back / Share).
           Only shows while a published dashboard is on screen. In edit mode the
           gear is hidden — Cancel/Save live as a floating pill on the canvas. -->
      <ng-container *ngIf="publishedToolbarState.active && !publishedToolbarState.editMode">
        <button mat-icon-button
                [matMenuTriggerFor]="publishedSettingsMenu"
                matTooltip="Dashboard settings" matTooltipPosition="below"
                aria-label="Dashboard settings"
                style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-menu #publishedSettingsMenu="matMenu" xPosition="before" class="dvm-settings-menu">
          <!-- Two groups, separated by a rule: what anyone viewing can do to the
               layout, then what only the owner can do with the dashboard. -->
          <div class="dvm-settings-menu-group">
            <span class="dvm-settings-menu-label">This layout</span>
            <button mat-menu-item [disabled]="!publishedToolbarState.hasWidgets" (click)="triggerPublishedAction('edit')">
              <mat-icon>dashboard_customize</mat-icon><span>Edit Layout</span>
            </button>
            <!-- Reset hidden by request; the action is still wired up in the published view.
            <button mat-menu-item [disabled]="!publishedToolbarState.hasWidgets" (click)="triggerPublishedAction('reset')">
              <mat-icon>restart_alt</mat-icon><span>Reset</span>
            </button>
            -->
          </div>
          <div class="dvm-settings-menu-group" *ngIf="publishedToolbarState.showOwnerActions">
            <span class="dvm-settings-menu-label">Dashboard</span>
            <button mat-menu-item (click)="triggerPublishedAction('back')">
              <mat-icon>arrow_back</mat-icon><span>Back to Builder</span>
            </button>
            <button mat-menu-item (click)="triggerPublishedAction('share')">
              <mat-icon>share</mat-icon><span>Share</span>
            </button>
            <button mat-menu-item [disabled]="!publishedToolbarState.hasWidgets" (click)="triggerPublishedAction('duplicate')">
              <mat-icon>content_copy</mat-icon><span>Duplicate to new dashboard</span>
            </button>
          </div>
        </mat-menu>
      </ng-container>

      <!-- User Guide — global (not scoped to the builder routes), so it sits in
           one predictable place next to the theme/settings controls. Hidden in
           project mode, which ships without the builder documentation
           the guide describes. -->
      <button *ngIf="!projectMode"
              mat-icon-button (click)="openGuide()"
              matTooltip="User Guide" matTooltipPosition="below"
              aria-label="Open User Guide"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>help_outline</mat-icon>
      </button>

      <button *ngIf="showThemeOptions"
              mat-icon-button (click)="openThemeSelector()"
              matTooltip="Theme Options" matTooltipPosition="below"
              matTooltipClass="dvm-theme-tooltip"
              aria-label="Theme Options"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>palette</mat-icon>
      </button>

      <!-- Save Theme — only visible when a previewed theme is pending save. -->
      <button *ngIf="showThemeOptions && hasPendingThemePreview"
              mat-stroked-button
              (click)="saveThemePreview()"
              matTooltip="Save the previewed theme"
              matTooltipPosition="below"
              aria-label="Save Theme"
              class="save-theme-btn"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97)); border-color: var(--dvm-toolbar-text, rgba(0,0,0,0.4));">
        <mat-icon style="margin-right: 4px;">save</mat-icon>
        <span>Save Theme</span>
      </button>

      <!-- Light/Dark theme toggle -->
      <button *ngIf="showThemeToggle"
              mat-icon-button
              (click)="toggleTheme()"
              [matTooltip]="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'"
              matTooltipClass="theme-toggle-tooltip"
              [attr.aria-label]="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>

      <div class="toolbar-action-popover">
        <button mat-icon-button class="toolbar-action-button" (click)="logout()"
                aria-label="Log out"
                style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
          <mat-icon>logout</mat-icon>
        </button>
        <div class="navbar-hover-popup navbar-hover-popup-end" role="tooltip">
          <span class="navbar-hover-popup-icon navbar-hover-popup-icon-danger">
            <mat-icon>logout</mat-icon>
          </span>
          <span class="navbar-hover-popup-copy">
            <strong>Log Out</strong>
            <small>End your current session</small>
          </span>
          <span class="navbar-hover-popup-action navbar-hover-popup-action-danger">
            Sign out <mat-icon>arrow_forward</mat-icon>
          </span>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <!-- Slideshow strip — fixed-positioned banner that sits directly below the
       top nav while a slideshow is running. Started from the Theme Options
       dialog's Slideshow tab; the dialog closes on Play so the user steers
       the cycling themes from this strip. Combines:
         · live theme name + counter on the left
         · transport controls (prev / play / next) in the centre cluster
         · Apply / Save / Stop on the right
         · the progress bar pinned to the strip's bottom edge
       Renders on a card-coloured surface so it stays clearly distinct from
       the toolbar above on every theme. -->
  <div *ngIf="slideshowActive"
       class="slideshow-strip"
       [style.top]="'var(--top-toolbar-height)'">
    <div class="slideshow-strip-inner">
      <!-- Meta: theme being previewed + position in queue. -->
      <div class="slideshow-strip-meta">
        <mat-icon class="slideshow-strip-icon">slideshow</mat-icon>
        <span class="slideshow-strip-label">Previewing</span>
        <span class="slideshow-strip-name" *ngIf="slideshowCurrentName">
          {{ slideshowCurrentName }}
        </span>
        <span class="slideshow-strip-counter" *ngIf="slideshowTotal">
          {{ slideshowIndex + 1 }} / {{ slideshowTotal }}
        </span>
      </div>

      <!-- Transport: prev / play-pause / next. -->
      <div class="slideshow-strip-transport">
        <button mat-icon-button class="slideshow-btn"
                (click)="slideshowPrev()"
                matTooltip="Previous theme"
                matTooltipPosition="below"
                aria-label="Previous theme">
          <mat-icon>skip_previous</mat-icon>
        </button>
        <button mat-icon-button class="slideshow-btn is-play"
                (click)="toggleSlideshowPlayback()"
                [matTooltip]="slideshowPlaying ? 'Pause' : 'Play'"
                matTooltipPosition="below"
                [attr.aria-label]="slideshowPlaying ? 'Pause slideshow' : 'Play slideshow'">
          <mat-icon>{{ slideshowPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
        </button>
        <button mat-icon-button class="slideshow-btn"
                (click)="slideshowNext()"
                matTooltip="Next theme"
                matTooltipPosition="below"
                aria-label="Next theme">
          <mat-icon>skip_next</mat-icon>
        </button>
      </div>

      <!-- Actions: Apply (preview-and-keep), Save (commit), Stop (cancel). -->
      <div class="slideshow-strip-actions">
        <button mat-flat-button class="slideshow-action is-apply"
                (click)="slideshowApply()"
                aria-label="Apply current theme">
          Apply
        </button>
        <button mat-flat-button class="slideshow-action is-save"
                (click)="slideshowSave()"
                aria-label="Save current theme">
          <mat-icon>save</mat-icon>
          <span>Save</span>
        </button>
        <button mat-icon-button class="slideshow-btn is-stop"
                (click)="slideshowStop()"
                matTooltip="Stop slideshow"
                matTooltipPosition="below"
                aria-label="Stop slideshow">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Progress bar pinned to the strip's bottom edge — fills 0%→100% over
         each slide cycle and resets on advance. Inside the strip so it
         visually belongs to the slideshow, not the top nav. -->
    <div class="slideshow-progress-bar"
         role="progressbar"
         [attr.aria-valuenow]="(slideshowProgress * 100) | number:'1.0-0'"
         aria-valuemin="0"
         aria-valuemax="100"
         aria-label="Slideshow progress">
      <div class="slideshow-progress-fill"
           [style.width.%]="slideshowProgress * 100"
           [class.paused]="!slideshowPlaying"></div>
    </div>
  </div>

  <aside *ngIf="showProjectModeRail"
         class="project-mode-rail"
         [class.is-uat-expanded]="projectModeUat && projectModeUatExpanded"
         aria-label="Published dashboards">
    <div class="project-mode-rail-shell">
      <div class="project-mode-rail-brand" [attr.title]="companyText">
        <button *ngIf="projectModeUat"
                type="button"
                class="project-mode-uat-menu"
                (click)="toggleProjectModeUatRail()"
                [attr.aria-expanded]="projectModeUatExpanded"
                [attr.aria-label]="projectModeUatExpanded ? 'Collapse navigation' : 'Expand navigation'">
          <mat-icon>menu</mat-icon>
        </button>
        <div *ngIf="!projectModeUat" class="project-mode-rail-avatar">{{ projectModeBrandMonogram }}</div>
      </div>
      <div class="project-mode-rail-list">
        <button type="button" class="project-mode-rail-item"
          *ngFor="let item of projectModeDashboardItems"
          [class.is-current]="item.active"
          [attr.aria-current]="item.active ? 'page' : null"
          [attr.title]="item.label"
          (click)="navigateTopNavigationItem(item.path)">
          <span class="project-mode-rail-item-icon"><mat-icon>{{ item.icon }}</mat-icon></span>
          <span *ngIf="projectModeUat" class="project-mode-rail-item-label">{{ item.label }}</span>
        </button>
      </div>
      <div class="project-mode-rail-footer" aria-hidden="true">
        <img *ngIf="projectModeUat && secondaryLogo"
             [src]="secondaryLogo"
             alt=""
             class="project-mode-uat-footer-logo">
        <div *ngIf="!projectModeUat" class="project-mode-rail-footer-icon"><mat-icon>settings</mat-icon></div>
        <div class="project-mode-rail-footer-wordmark">
          <!-- <strong>SIM</strong><small>FOUNDRY</small><span>3.0</span> -->
        </div>
      </div>
    </div>
  </aside>

  <!-- MAIN LAYOUT -->
  <mat-sidenav-container class="flex-1 h-full" [autosize]="true">

    <!-- SIDENAV -->
                    <mat-sidenav
                      *ngIf="false"
                      [mode]="isMobileLayout ? 'over' : 'side'"
                      [opened]="isMobileLayout ? isMobileDrawerOpen : true"
                      class="sidenav transition-all duration-300 ease-in-out"
                      [class.is-resizing]="isResizingSidebar"
                      [style.overflow]="'hidden'"
                      style="top: calc(var(--top-toolbar-height) + var(--slideshow-strip-h, 0px) + var(--builder-toolbar-gap, 0px));
                        height: calc(var(--dvh, 100vh) - var(--top-toolbar-height) - var(--slideshow-strip-h, 0px) - var(--builder-toolbar-gap, 0px));
                        box-shadow: 4px 0 10px rgba(1,12,60,0.2);
                        z-index: 1000;
                        background-color: var(--dvm-sidebar-bg, #97c6f9);
                        color: var(--dvm-sidebar-text, #000);"
                      [style.width]="isMobileLayout ? '84vw' : (isCollapsed ? '72px' : sidebarExpandedWidth + 'px')"
                      [style.transition]="isResizingSidebar ? 'none' : null">

      <div class="flex items-center justify-between px-3" style="padding-top: 24px; padding-bottom: 8px;">
        <button mat-icon-button (click)="toggleSidebar()"
          style="color: var(--dvm-sidebar-text, rgb(18,17,17));">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <!-- MENU -->
      <mat-nav-list>
        <ng-container *ngFor="let item of displayedMenuItems">

          <!-- NO CHILD -->
          <a mat-list-item
             *ngIf="!hasChildren(item)"
             class="menuItems flex items-center px-4"
             [routerLink]="item.path"
             [ngClass]="{'active-item': isActive(item)}"
             [ngClass]="{'justify-center': isCollapsed}"
             [matTooltip]="item.name"
             matTooltipPosition="right">

            <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
              {{ item.icon }}
            </mat-icon>

            <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);"
                  [ngClass]="{'hidden': isCollapsed}">
              {{ item.name }}
            </span>
          </a>

          <!-- WITH CHILD -->
          <ng-container *ngIf="hasChildren(item)">
            <a mat-list-item
               class="menuItems flex items-center px-4"
               (click)="toggleSubmenu(item.name, $event)"
               [ngClass]="{'justify-center': isCollapsed}"
               [matTooltip]="item.name"
               matTooltipPosition="right">

              <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                {{ item.icon }}
              </mat-icon>

              <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);"
                    [ngClass]="{'hidden': isCollapsed}">
                {{ item.name }}
              </span>

              <mat-icon *ngIf="!isCollapsed && item.name !== 'Quotes'" style="margin-left:auto; color: var(--dvm-sidebar-text, black); padding-top:5px;">
                {{ isMenuExpanded(item.name) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </a>

            <!-- CHILD LIST -->
            <div *ngIf="isMenuExpanded(item.name) && !isCollapsed" class="submenu">
              <ng-container *ngFor="let child of item.children">

                <!-- Child without grandchildren -->
                 <a mat-list-item
                   *ngIf="!hasChildren(child)"
                   class="menuItems child-menu px-4"
                   [routerLink]="child.path"
                   [ngClass]="{'active-item': isActive(child)}"
                   [matTooltip]="child.name"
                   matTooltipPosition="right">

                  <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                    {{ child.icon }}
                  </mat-icon>

                  <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                    {{ child.name }}
                  </span>
                </a>

                <!-- Child with grandchildren -->
                <ng-container *ngIf="hasChildren(child)">
                  <a mat-list-item
                     class="menuItems child-menu px-4"
                     (click)="toggleSubmenu(child.name, $event)"
                     [matTooltip]="child.name"
                     matTooltipPosition="right">

                    <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                      {{ child.icon }}
                    </mat-icon>

                    <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                      {{ child.name }}
                    </span>

                    <mat-icon *ngIf="child.name !== 'Manage Quotes'" style="margin-left:auto; color: var(--dvm-sidebar-text, black); ">
                      {{ isMenuExpanded(child.name) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </a>

                  <!-- Grandchild list -->
                  <div *ngIf="isMenuExpanded(child.name)" class="grandchild-menu">
                    <a mat-list-item
                       *ngFor="let grandchild of child.children"
                       class="menuItems grandchild-menu px-4"
                       [routerLink]="grandchild.path"
                       [ngClass]="{'active-item': isActive(grandchild)}"
                       [matTooltip]="grandchild.name"
                       matTooltipPosition="right">

                      <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                        {{ grandchild.icon }}
                      </mat-icon>

                       <span style="padding-left:40px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                        {{ grandchild.name }}
                      </span>
                    </a>
                  </div>
                </ng-container>

              </ng-container>
            </div>

          </ng-container>

        </ng-container>
      </mat-nav-list>

      <!-- Sidebar bottom branding block (shown in both use cases when alt sidenav is off) -->
      <div *ngIf="!useAltSidenav"
           class="sidenav-branding-bottom"
           [class.collapsed]="isCollapsed">

        <!-- Need Help / Get Support card — shown in both Use Case 1 and Use Case 2 -->
        <!-- <div *ngIf="!isCollapsed" class="help-card">
          <div class="help-title">Need Help?</div>
          <div class="help-subtitle">Contact support for assistance</div>
          <button class="get-support-btn" (click)="goToHelp()">Get Support</button>
        </div> -->

        <!-- SIM Advisory logo + text — only Use Case 2 (client logo in toolbar means SIMA moves here) -->
        <div *ngIf="hasClientLogo" class="sim-branding" [class.collapsed]="isCollapsed">
          <img [src]="logo" alt="SIM Advisory" class="sim-logo">
          <span *ngIf="!isCollapsed" class="sim-text">{{ companyText }}</span>
        </div>
      </div>

      <!-- Resize handle — drag to set sidebar width. Hidden on mobile and
           when collapsed. Persists to localStorage on release. -->
      <div *ngIf="!isMobileLayout && !isCollapsed"
           class="sidebar-resize-handle"
           [class.dragging]="isResizingSidebar"
           role="separator"
           aria-label="Resize sidebar"
           aria-orientation="vertical"
           (pointerdown)="startSidebarResize($event)">
      </div>

    </mat-sidenav>

    <!-- CONTENT -->
    <mat-sidenav-content
      class="bg-gray-100 transition-all duration-300 ease-in-out overflow-auto"
      style="margin-top: calc(var(--top-toolbar-height) + var(--slideshow-strip-h, 0px) + var(--builder-toolbar-gap, 0px)); height: calc(var(--dvh, 100vh) - var(--top-toolbar-height) - var(--slideshow-strip-h, 0px) - var(--builder-toolbar-gap, 0px));"
      [style.margin-left.px]="showProjectModeRail ? projectRailOffsetPx : null">

      <div
        class="route-content-shell"
        [class.edge-to-edge]="isDashboardRoute || isSelfServiceRoute || isStandaloneBuilderRoute"
        [style.margin]="isFullBleedRoute ? '0' : '1.5rem'"
        [style.height]="isFullBleedRoute ? '100%' : null"
        [style.min-height]="isFullBleedRoute ? '0' : null">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>

  <!-- Global floating chat assistant — mounted once here so it shows on
       every routed screen (dashboards, builders, published views) without
       per-page duplication. Backed by the same ChatApiService/session the
       routed /chat page and in-dashboard chat widget already use. -->
  <app-floating-chat-widget *ngIf="showChatAssistant"></app-floating-chat-widget>
</div>
